export enum GrowChecklistStepState {
  Number = 'number',
  Done = 'done',
  Skipped = 'skipped',
}
